import React from "react";

import HomeLayout from "../components/HomeLayout";
import HomePortal from "../components/HomePortal";
import image from "../assets/images/placeholder.jpg";

const Page = () => {
	const ownPortals = [
		{ headline: "Republic of Finland", image: image, to: "/finland" },
		{ headline: "Republic of Finland", image: image, to: "/finland" },
		{ headline: "Republic of Finland", image: image, to: "/finland" },
		{ headline: "Republic of Finland", image: image, to: "/finland" }
	];
	const recommendedPortals = [
		{
			headline: "Republic of Finland",
			image: image,
			price: "29.99 €",
			description: "Lorem ipsum dolor sit amet"
		},
		{
			headline: "Republic of Finland",
			image: image,
			price: "29.99 €",
			description: "Lorem ipsum dolor sit amet"
		},
		{
			headline: "Republic of Finland",
			image: image,
			price: "29.99 €",
			description: "Lorem ipsum dolor sit amet"
		},
		{
			headline: "Republic of Finland",
			image: image,
			price: "29.99 €",
			description: "Lorem ipsum dolor sit amet"
		}
	];

	return (
		<HomeLayout>
			<HomePortal
				ownPortals={ownPortals}
				recommendedPortals={recommendedPortals}
			/>
		</HomeLayout>
	);
};

export default Page;
